export default {
    part2: [
        { 
            cover: require('@/assets/images/home/pc_03.png'),
            title: '采购溯源系统',
            disc: '通过电商采购平台实现对采购过程、 溯源信息、财务结算等的信息化管理。'
        },
        { 
            cover: require('@/assets/images/home/pc_04.png'),
            title: '食堂管理系统',
            disc: '云平台+物联网终端实现对食堂运营、管理的全流程、自动化、精细化管理。'
        },
        { 
            cover: require('@/assets/images/home/pc_02.png'),
            title: '大数据监管系统',
            disc: '大数据分析、AI智能预警、远程巡检、社会监督等手段，可以加大监管力度、降低监管难度。'
        },
    ],

    part3: [
        { 
            cover: require('@/assets/images/home/pc_05.png'),
            title: '教育服务企业',
            disc: '帮助构建教育后勤服务综合管理体系'
        },
        { 
            cover: require('@/assets/images/home/pc_06.png'),
            title: '教育局/市监局',
            disc: '解决校园食堂食品安全监管'
        },
        { 
            cover: require('@/assets/images/home/pc_07.png'),
            title: '团餐企业',
            disc: '协助企业实现精细化管理'
        },
    ],

    part4: [
        { 
            cover: require('@/assets/images/home/pc_08.png'),
            title: '行业资讯',
            disc: '区域教育后勤服务运营管理方案，校园食堂食品安全管理方案校园食堂。食品安全管理方案。'
        },
        { 
            cover: require('@/assets/images/home/pc_09.png'),
            title: '企业动态',
            disc: '校园食堂食品安全管理方案校园食堂食品安全管理方案校园，食堂食品安全管理方案校园食堂食品安全管理方案校园。食堂食品安全管理方案校园食堂食，品安全管理方案校园食，堂食品安全管理方案校园食堂食品安全管理方案。'
        },
    ],


}
